/**
 * Created by jonas on 2022-06-15.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {BS2} from "../../../BS2";
import {BS2Statics} from "../../../config/BS2Statics";
import {BS2Symbol} from "../../../reels/BS2Symbol";


export class SanityCheckPresentation implements SimplePresentation {
    public static run: boolean = false;

    constructor() {
    }

    public static checkFinalSymbolSizes(symbolSizes: number[][], calledFromWhichClass: string): void {
        for (let reelIdx: number = 0; reelIdx < BS2Statics.NR_OF_REELS; reelIdx++) {
            for (let symIdx: number = 0; symIdx < 5; symIdx++) {
                const sym: BS2Symbol = (<BS2Symbol>BS2.reelView.reels[reelIdx].model.getVisibleSymbolAt(symIdx).positionable),
                    size: number = symbolSizes[reelIdx][symIdx],
                    returnedSize: number = sym.verifyFinalSymSize(size);
                if (returnedSize !== size && !BS2.reelView.reels[reelIdx].model.getVisibleSymbolAt(symIdx).removed) {
                    debugger
                }
            }
        }
    }


    public static checkSymNames(reel: string[][]): void {
        const reels: string[][] = JSON.parse(JSON.stringify(reel));
        if (reels[0].length === 7) {
            for (let reelIdx: number = 0; reelIdx < reels.length; reelIdx++) {
                reels[reelIdx].pop();
                reels[reelIdx].shift();
            }

        }
        if (BS2.model.data.nextMode.indexOf("AVALANCHE") > -1) {
            for (let reelIdx: number = 0; reelIdx < reels.length; reelIdx++) {
                for (let symIdx: number = 0; symIdx < reels[reelIdx].length; symIdx++) {
                    const clientSymName = BS2.reelView.reels[reelIdx].model.getAllVisibleSymbols()[symIdx];
                    if (reels[reelIdx][symIdx] === "X" && clientSymName.removed) {
                        continue;
                    }

                    //d and g are wilds for game data
                    if (BS2.model.gameData &&
                        BS2.model.gameData.evaluatedArea[reelIdx][symIdx] === "W" &&
                        BS2Statics.SPLIT_SYMBOLS.includes(reels[reelIdx][symIdx]) &&
                        clientSymName.name === "W") {
                        continue;
                    }
                    //d and g are wilds for init data
                    if (BS2.model.initData.isRestoreState &&
                        clientSymName.name === "W" &&
                        BS2Statics.SPLIT_SYMBOLS.includes(reels[reelIdx][symIdx])) {
                        continue;
                    }

                    if (clientSymName.name !== reels[reelIdx][symIdx]) {
                        debugger;
                    }
                }
            }
        } else {
            for (let reelIdx: number = 0; reelIdx < reels.length; reelIdx++) {
                for (let symIdx: number = 0; symIdx < reels[reelIdx].length; symIdx++) {
                    const clientSymName = BS2.reelView.reels[reelIdx].model.getAllVisibleSymbols()[symIdx];
                    if (reels[reelIdx][symIdx] === "X" && clientSymName.removed) {
                        continue;
                    }

                    //d and g are wilds for game data
                    if (BS2.model.gameData &&
                        BS2.model.gameData.evaluatedArea[reelIdx][symIdx] === "W" &&
                        BS2Statics.SPLIT_SYMBOLS.includes(reels[reelIdx][symIdx]) &&
                        clientSymName.name === "W") {
                        continue;
                    }
                    //d and g are wilds for init data
                    if (BS2.model.initData.isRestoreState &&
                        clientSymName.name === "W" &&
                        BS2Statics.SPLIT_SYMBOLS.includes(reels[reelIdx][symIdx])) {
                        continue;
                    }

                    if (clientSymName.name !== reels[reelIdx][symIdx]) {
                        debugger;
                    }
                }
            }
        }
    }

    shouldRun(): boolean {
        return SanityCheckPresentation.run;
    }

    start(controller: SimplePresentationRunnerController): void {
        SanityCheckPresentation.checkFinalSymbolSizes(BS2.model.gameData.nextMode.indexOf("AVALANCHE") > -1 ? BS2.model.gameData.symbolSizesAfterCollapse : BS2.model.gameData.symbolSizes, "SanityCheckPresentation");
        // SanityCheckPresentation.checkSymNames(BS2.model.gameData.nextMode.indexOf("AVALANCHE") > -1 ? BS2.model.gameData.reelsAfterCollapse : BS2.model.gameData.reels);
        controller.finish();
    }


}